__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerForgotPasswordContent-module-scss-module__zaQsuW__accordionSlideOverwrite",
  "fadeIn": "partnerForgotPasswordContent-module-scss-module__zaQsuW__fadeIn",
  "fadeOut": "partnerForgotPasswordContent-module-scss-module__zaQsuW__fadeOut",
  "footer": "partnerForgotPasswordContent-module-scss-module__zaQsuW__footer",
  "header": "partnerForgotPasswordContent-module-scss-module__zaQsuW__header",
  "loginLink": "partnerForgotPasswordContent-module-scss-module__zaQsuW__loginLink",
  "main": "partnerForgotPasswordContent-module-scss-module__zaQsuW__main",
  "scaleIn": "partnerForgotPasswordContent-module-scss-module__zaQsuW__scaleIn",
  "scaleOut": "partnerForgotPasswordContent-module-scss-module__zaQsuW__scaleOut",
  "subtitle": "partnerForgotPasswordContent-module-scss-module__zaQsuW__subtitle",
  "title": "partnerForgotPasswordContent-module-scss-module__zaQsuW__title",
  "zoomIn": "partnerForgotPasswordContent-module-scss-module__zaQsuW__zoomIn",
  "zoomOut": "partnerForgotPasswordContent-module-scss-module__zaQsuW__zoomOut",
});
